"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENCODER = exports.WHITELIST_ENTRY_PREFIX = exports.ORACLE_PREFIX = void 0;
exports.ORACLE_PREFIX = 'oracle';
exports.WHITELIST_ENTRY_PREFIX = 'whitelist_entry';
exports.ENCODER = new TextEncoder();
